export const STAFF_OPTIONS = [
  { id: "stanko", label: "Stanko" },
  { id: "novak", label: "Novák" },
  { id: "cimerhanzl", label: "Cimerhanzl" },
  { id: "burian", label: "Burian" },
  { id: "mackova", label: "Mačková" },
  { id: "partykova", label: "Partyková" },
  { id: "dalsi", label: "Další (ručně)" },
];

export const SPEAKER_OPTIONS = [
  { id: "mackova", label: "Mačková" },
  { id: "partykova", label: "Partyková" },
  { id: "talirova", label: "Talířová" },
  { id: "obradnice", label: "Obřadnice dle služby" },
  { id: "rodina_sama", label: "Rodina si mluví sama" },
  { id: "dalsi", label: "Další (ručně)" },
];

export const MUSIC_TYPE_OPTIONS = [
  { id: "reprodukovana", label: "Reprodukovaná hudba" },
  { id: "ziva_dechova", label: "Živá dechová" },
  { id: "vlastni_od_rodiny", label: "Vlastní od rodiny" },
];

export const MUSIC_PERSON_OPTIONS = [
  { id: "snoblova", label: "Šnoblová" },
  { id: "stanko", label: "Stanko" },
  { id: "dalsi", label: "Další (ručně)" },
];

export const VEHICLE_OPTIONS = [
  { id: "1CA3338", label: "Nové 4x4" },
  { id: "9C28894", label: "Šedé 9C28894" },
  { id: "5C09767", label: "Hnědé 5C09767" },
];

export function getStaffLabel(idOrLabel) {
  const v = String(idOrLabel || "").trim();
  return STAFF_OPTIONS.find((x) => x.id === v)?.label || v || "-";
}

export function getSpeakerLabel(idOrLabel) {
  const v = String(idOrLabel || "").trim();
  return SPEAKER_OPTIONS.find((x) => x.id === v)?.label || v || "-";
}

export function getMusicTypeLabel(idOrLabel) {
  const v = String(idOrLabel || "").trim();
  return MUSIC_TYPE_OPTIONS.find((x) => x.id === v)?.label || v || "-";
}

export function getMusicPersonLabel(idOrLabel) {
  const v = String(idOrLabel || "").trim();
  return MUSIC_PERSON_OPTIONS.find((x) => x.id === v)?.label || v || "-";
}

export function getVehicleLabelById(idOrLabel) {
  const v = String(idOrLabel || "").trim();
  return VEHICLE_OPTIONS.find((x) => x.id === v)?.label || v || "-";
}

export const PERSON_ROLE_DEFS = [
  { key: "spravce_zakazky", label: "Správce zakázky", group: "obecne" },
  { key: "komunikace_s_rodinou", label: "Komunikace s rodinou", group: "obecne" },

  { key: "sjednani_obradu", label: "Sjednání obřadu", group: "obrad" },
  { key: "vedouci_obradu", label: "Vedoucí obřadu", group: "obrad" },
  { key: "recnik", label: "Řečník", group: "obrad" },
  { key: "hudba", label: "Hudba", group: "obrad" },
  { key: "uprava_zesnuleho", label: "Úprava zesnulého", group: "obrad" },
  { key: "obradni_sluzba", label: "Obřadní služba", group: "obrad" },
  { key: "hlavni_organizace", label: "Hlavní organizace", group: "obrad" },

  { key: "koordinator_prevozu", label: "Koordinátor převozu", group: "prevoz" },
  { key: "ridic_prevozu", label: "Řidič převozu", group: "prevoz" },
  { key: "doprovod_prevozu", label: "Doprovod převozu", group: "prevoz" },

  { key: "recnice_priprava", label: "Řečnice - příprava", group: "rec" },
  { key: "recnice_obrad", label: "Řečnice - obřad", group: "rec" },
];

export const VEHICLE_ROLE_DEFS = [
  { key: "prevozove_auto", label: "Převozové auto" },
  { key: "hlavni_vuz", label: "Hlavní vůz" },
  { key: "doprovodne_auto", label: "Doprovodné auto" },
];

export const EVENT_TYPE_DEFS = {
  prevoz: {
    label: "Převoz",
    bufferBeforeMin: 15,
    bufferAfterMin: 20,
    requiredPersonRoles: ["ridic_prevozu"],
    requiredVehicleRoles: ["prevozove_auto"],
  },
  obrad: {
    label: "Obřad",
    bufferBeforeMin: 30,
    bufferAfterMin: 25,
    requiredPersonRoles: ["vedouci_obradu"],
    requiredVehicleRoles: [],
  },
  sjednani: {
    label: "Sjednání",
    bufferBeforeMin: 10,
    bufferAfterMin: 10,
    requiredPersonRoles: ["sjednani_obradu"],
    requiredVehicleRoles: [],
  },
  kremace: {
    label: "Kremace",
    bufferBeforeMin: 15,
    bufferAfterMin: 15,
    requiredPersonRoles: [],
    requiredVehicleRoles: [],
  },
  rec: {
    label: "Řeč / řečnice",
    bufferBeforeMin: 20,
    bufferAfterMin: 10,
    requiredPersonRoles: [],
    requiredVehicleRoles: [],
  },
  vydej_urny: {
    label: "Výdej urny",
    bufferBeforeMin: 10,
    bufferAfterMin: 10,
    requiredPersonRoles: [],
    requiredVehicleRoles: [],
  },
  interni_blokace: {
    label: "Interní blokace",
    bufferBeforeMin: 0,
    bufferAfterMin: 0,
    requiredPersonRoles: [],
    requiredVehicleRoles: [],
  },
};

export function getPersonRoleLabel(roleKey) {
  return PERSON_ROLE_DEFS.find((x) => x.key === roleKey)?.label || roleKey || "-";
}

export function getVehicleRoleLabel(roleKey) {
  return VEHICLE_ROLE_DEFS.find((x) => x.key === roleKey)?.label || roleKey || "-";
}

export function getEventTypeDef(type) {
  return EVENT_TYPE_DEFS[type] || {
    label: type || "-",
    bufferBeforeMin: 0,
    bufferAfterMin: 0,
    requiredPersonRoles: [],
    requiredVehicleRoles: [],
  };
}

export function getEventTypeLabel(type) {
  return getEventTypeDef(type).label;
}
